import { HTML_TAGS_REGEX, PUNCTUATION_REGEX } from './constants';
import { descriptionCute } from '@/utils/helpers';

/**
 * Removes HTML tags from text
 */
export const removeHtmlTags = (text: string): string => {
  return text.replace(HTML_TAGS_REGEX, '');
};

/**
 * Sanitizes title by removing HTML tags and Prusa Knowledge Base suffix
 */
export const sanitizeTitle = (title: string): string => {
  const titleWithoutTags = removeHtmlTags(title);
  return titleWithoutTags.replace(' | Prusa Knowledge Base', '');
};

/**
 * Sanitizes description by removing HTML tags and applying description formatting
 */
export const sanitizeDescription = (description?: string): string => {
  if (!description) return '';
  const descriptionWithoutTags = removeHtmlTags(description);
  return descriptionCute(descriptionWithoutTags);
};

/**
 * Processes search expression to generate highlight words including stemmed variations
 */
export const processSearchExpression = (searchExpression: string): string[] => {
  const words = decodeURIComponent(searchExpression).split(' ');

  // Take words longer than 4 characters and remove the last letter
  const wordsToHighlight = words.filter(word => word.length > 4).map(word => word.slice(0, -1));

  const normalizedStrings = words.map(word => word.toLowerCase());

  const withoutPunctuation = normalizedStrings.map(word => word.replace(PUNCTUATION_REGEX, ''));

  return [...words, ...wordsToHighlight, ...withoutPunctuation];
};
